import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AdminService} from "../../../../services/admin.service";
import {TreeNode} from "primeng/primeng";

@Injectable()
export class UserQualificationsService {

  public nodes: TreeNode[] = [];
  public nodeId = '';
  public nodeName = '';
  public nodeType = '';
  public nodeLevel = '';
  public nodeDate = '';
  public selectedNode: TreeNode;

  public userId;

  public noQualifications = false;
  public getQualificationsError = false;

  isLoaded = false;

  constructor(private http: HttpClient,
              private adminService: AdminService) {
  }

  clearNodeSelection() {
    this.nodeId = '';
    this.nodeName = '';
    this.nodeType = '';
  }

  setNodes(value: TreeNode[]) {
    this.nodes = value;
  }

  getUserQualifications(uid) {
    return this.adminService.getLearningSpecsProfile(uid);
  }

  updateTree() {
    this.adminService.getLearningSpecsProfile(this.userId).subscribe(
      (response: any) => {
        this.setNodes(response.body);
      },
      () => {
      }
    );
  }


}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/qualifications/services/user-qualifications.service.ts